import { connect } from 'react-redux'
import ProjectReturnLink from './ProjectReturnLink'

const mapStateToProps = (state, ownProps) => {
  return {
    url: state.project.url
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return { }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectReturnLink)





// WEBPACK FOOTER //
// ./src/components/ProjectReturnLink/index.js